import { writable } from 'svelte/store';

import type { IndustryCentroid } from '$lib/api/data';

/**
 * The category whose profile has the screen, if any.
 *
 * # Why a store rather than state in the tree
 *
 * The profile is a screen, not a panel floating over one — see ScreenView,
 * which is explicit that a box in the middle of a wide window is the dialog
 * this app spent an afternoon removing. So it replaces the screen it was opened
 * from, and the thing that owns that screen is the host: GuidedSearch for the
 * industry step, the layout for the picker the filter bar opens.
 *
 * The button that opens it is a row deep inside IndustryTree, three components
 * below either host. A store is the shortest line between the two, and it is
 * how the tree already talks to its hosts about the search text.
 */
export const industryProfile = writable<IndustryCentroid | null>(null);

/**
 * Which industry groups are open in the tree.
 *
 * Kept outside the component because the profile takes the whole screen, which
 * unmounts the tree behind it. Held in the component, the expansion went with
 * it: a customer who opened Handwerk & Ausbau, read one category and came back
 * landed on a fully collapsed list with no sign of where they had been.
 */
export const expandedIndustryGroups = writable<Set<number>>(new Set());
